import { CSSProperties, ReactNode } from 'react';
import classNames from 'classnames';

import styles from './page-block.module.css';

interface PageBlockProps {
  id?: string,
  className?: string,
  titleClassName?: string,
  contentClassName?: string,
  style?: CSSProperties,
  title?: ReactNode,
  children: ReactNode,
  variant?: 'default' | 'white' | 'filled' | 'dark' | 'light'
}

const PageBlock = ({ id, className, style, title, children, variant, contentClassName, titleClassName }: PageBlockProps) => {
  return (
    <div className={classNames(styles.root, className, variant && styles[variant])} style={style} id={id}>
      <div className="container">
        {title && (
          typeof title === 'string' ? <h3 className={classNames(styles.title, titleClassName)} dangerouslySetInnerHTML={{ __html: title }} /> : <h3 className={classNames(styles.title, titleClassName)}>{title}</h3>
        )}
        <div className={classNames(styles.content, contentClassName)}>{children}</div>
      </div>
    </div>
  );
};

export default PageBlock;
